import { Button } from '~/components/elements/Button'
import { FavoriteIcon } from '~/components/icons/generated/FavoriteIcon'

type Props = {
  favoriteCount: number
  onButtonClick: () => void
}

export const FavoriteButtonForPc: React.FC<Props> = ({
  favoriteCount,
  onButtonClick,
}) => {
  return (
    <div className="w-[208px]">
      <Button color="outlined" onClick={onButtonClick}>
        <span className="flex h-[42px] items-center text-[13px] font-bold text-gray-600">
          <span className="flex-1">
            お気に入り (<span className="text-[14px]">{favoriteCount}</span>)
          </span>
          <span className="flex aspect-square h-full items-center justify-center border-l pt-[2px]">
            <FavoriteIcon className="h-[22px]" />
          </span>
        </span>
      </Button>
    </div>
  )
}
